import w200 from "./bannerbg3_oj7f95_c_scale,w_200.webp";
import w394 from "./bannerbg3_oj7f95_c_scale,w_394.webp";
import w537 from "./bannerbg3_oj7f95_c_scale,w_537.webp";
import w638 from "./bannerbg3_oj7f95_c_scale,w_638.webp";
import w656 from "./bannerbg3_oj7f95_c_scale,w_656.webp";
import w968 from "./bannerbg3_oj7f95_c_scale,w_968.webp";
import w969 from "./bannerbg3_oj7f95_c_scale,w_969.webp";
import w1033 from "./bannerbg3_oj7f95_c_scale,w_1033.webp";
import w1083 from "./bannerbg3_oj7f95_c_scale,w_1083.webp";
import w1270 from "./bannerbg3_oj7f95_c_scale,w_1270.webp";
import w1284 from "./bannerbg3_oj7f95_c_scale,w_1284.webp";
import w1345 from "./bannerbg3_oj7f95_c_scale,w_1345.webp";
import w1391 from "./bannerbg3_oj7f95_c_scale,w_1391.webp";
import w1398 from "./bannerbg3_oj7f95_c_scale,w_1398.webp";
import w1400 from "./bannerbg3_oj7f95_c_scale,w_1400.webp";

export default {
  "200w": w200,
  "394w": w394,
  "537w": w537,
  "638w": w638,
  "656w": w656,
  "968w": w968,
  "969w": w969,
  "1033w": w1033,
  "1083w": w1083,
  "1270w": w1270,
  "1284w": w1284,
  "1345w": w1345,
  "1391w": w1391,
  "1398w": w1398,
  "1400w": w1400,
};
